import { render, staticRenderFns } from "./FIBStatus.vue?vue&type=template&id=52463a9a&scoped=true&"
import script from "./FIBStatus.vue?vue&type=script&lang=js&"
export * from "./FIBStatus.vue?vue&type=script&lang=js&"
import style0 from "./FIBStatus.vue?vue&type=style&index=0&id=52463a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52463a9a",
  null
  
)

export default component.exports
import QSpinnerPuff from 'quasar/src/components/spinner/QSpinnerPuff.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerPuff});
